import React, { FC } from 'react';

import styles from './DashboardConfirmDialog.module.scss';

type Props = {
  onClick: () => void;
  confirmMessage: string;
  buttonText: string;
  buttonColor?: 'blue';
};

const DashboardConfirmDialog: FC<Props> = ({ onClick, confirmMessage, buttonText, buttonColor }) => {
  return (
    <div className={styles.dialog_inner}>
      <p className={styles.dialog_confirm_text}>{confirmMessage}</p>
      <button
        className={`${styles.confirm_button} ${buttonColor === 'blue' ? styles.button_blue : ''}`}
        onClick={onClick}
      >
        {buttonText}
      </button>
    </div>
  );
};

export default DashboardConfirmDialog;
